import React from 'react';
import Accordion from '../Accordion';
import Button from '../Button';
import './Contacts.css';
import img from '../../img/maps2.jpg'
import img2 from '../../img/logos2.png'

const Contacts = () => {
  const mapAccordionItems = [
    {
      title: "Открыть карту",
      content: (
        <>
          <div className="coordinates">
            <span>54.732107, 55.917617</span>
          </div>
          <div className="map-image">
            <a href="https://yandex.ru/maps/-/CHBQzSnS" title="панорама" target="_blank" rel="noopener noreferrer">
              <img src={img} alt="Карта расположения" />
            </a>
          </div>
        </>
      )
    }
  ];

  return (
    <>
      <section className="contacts-header">
        <div className="container">
          <div className="contacts-header-content">
            <h2 className="contacts-main-title">СВЯЗЬ И АДРЕС</h2>
            <p className="contacts-main-subtitle">
              Мы рады всем <span className="highlight">и всегда готовы выслушать вас</span>
            </p>
          </div>
        </div>
      </section>

      <section className="contacts" id="contacts">
        <div className="container">
          <div className="contacts-content">
            <div className="contacts-row">
              <div className="contacts-col contacts-info">
                <div className="contacts-section">
                  <h3 className="contacts-title">КОНТАКТЫ</h3>
                  <div className="contact-spacer"></div>

                  <div className="contact-item" onClick={() => window.open('tel:+79871329881')}>
                    <a href="tel:+79871329881">+7(987)13-29-881</a>
                  </div>

                  <div className="contact-spacer-small"></div>

                  <div className="contact-item" onClick={() => window.location.href = 'https://t.me/+79871329881'}>
                    <a href="https://t.me/+79871329881" target="_blank" rel="noopener noreferrer">
                      Чат в Telegram
                    </a>
                  </div>

                  <div className="contact-spacer-small"></div>

                  <div className="contact-item" onClick={() => window.location.href = 'https://wa.me/+79871329881?text=Белая_Гостиница_Проживание_и_регистрация'}>
                    <a href="https://wa.me/+79871329881?text=Белая_Гостиница_Проживание_и_регистрация" target="_blank" rel="noopener noreferrer">
                      Чат в WhatsApp
                    </a>
                  </div>

                  <div className="contact-spacer-medium"></div>

                  <div className="contact-item">
                    <a href="mailto:oooural@internet.ru">oooural@internet.ru</a>
                  </div>

                  <div className="contact-spacer-medium"></div>

                  <Button
                    href="https://wa.me/+79871329881?text=Бронировать_номер_в_гостинице_Белая"
                    variant="secondary"
                    className="booking-button"
                  >
                    БРОНЬ НОМЕРА
                  </Button>
                </div>
              </div>

              <div className="contacts-col contacts-address">
                <div className="contacts-section">
                  <h3 className="contacts-title">АДРЕС</h3>
                  <div className="contact-spacer"></div>

                  <div className="address-item">
                    <a
                      href="https://go.2gis.com/waVcm"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="На большую карту!"
                    >
                      г. Уфа, ул. Правая Белая, 12<br />
                      Остановка Соц. университет
                    </a>
                  </div>

                  <div className="contact-spacer-xs"></div>

                  <Accordion items={mapAccordionItems} className="map-accordion" />
                </div>
              </div>

              <div className="contacts-col contacts-logo">
                <div className="logo-spacer"></div>
                <div className="contacts-logo-image">
                  <img src={img2} alt="Гостиница Белая" />
                </div>
              </div>
            </div>

            <div className="contact-item contact-politic">
              <a href="/privacy-policy">Политика конфиденциальности</a>
            </div>


          </div>
        </div>
      </section>
    </>
  );
};

export default Contacts;